<template>
  <div class="invoiceHistory">
    <van-nav-bar
      title="开票历史"
      left-text=""
      left-arrow
      class="main-nav"
      @click-left="onClickLeft"
      fixed
    />
    <div
      class="invoiceHistory_content"
      v-loading="loading"
      element-loading-text="数据加载中..."
    >
      <div class="invoiceHistory_content_listBox">
        <!-- <van-pull-refresh v-model="refreshing" @refresh="onRefresh"> -->
        <van-list
          v-model="loading"
          :finished="finished"
          :immediate-check="false"
          :finished-text="finishedText"
          error-text="数据加载失败"
          @load="onReachBottom"
        >
          <div class="noData" v-if="list.length == 0">
            <img src="../../assets/images/setting/noData.png" />
            <p>暂时没有发票</p>
          </div>
          <template v-else>
            <div
              class="invoiceHistory_content_list"
              v-for="item in list"
              :key="item.id"
              @click="goDetail(item)"
            >
              <div class="invoiceHistory_content_list_top">
                <div class="invoiceHistory_content_list_top_time">
                  {{ item.createTime }}
                </div>
                <div
                  class="invoiceHistory_content_list_top_flag"
                  :style="{
                    color:
                      item.state == 0
                        ? '#00AADF'
                        : item.state == 2
                        ? '#949C9D'
                        : '#EE3721',
                  }"
                >
                  {{
                    item.state == 0
                      ? "开票中..."
                      : item.state == 1
                      ? "已取消"
                      : item.state == 2
                      ? "开票成功"
                      : "已注销"
                  }}
                </div>
              </div>
              <p class="invoiceHistory_content_list_name">{{ item.title }}</p>
              <div class="invoiceHistory_content_list_price">
                <p class="invoiceHistory_content_list_price_left">电子发票</p>
                <p class="invoiceHistory_content_list_price_rig">
                  ￥<span>{{ item.amount }}</span>
                </p>
              </div>
            </div>
          </template>
        </van-list>
        <!-- </van-pull-refresh> -->
      </div>
    </div>
  </div>
</template>
<script>
import { _invoiceList } from "../../api/setting";
export default {
  name: "invoiceHistory",
  data() {
    return {
      list: [], //列表数据
      refreshing: false, //上拉标识
      pageNum: 1, //当前页数
      finished: false, //下拉结束标识
      finishedText: "", //下拉话术
      loading: false, //loading标识
    };
  },
  created() {
    this.getInvoiceList();
  },
  mounted() {
    // this.onRefresh();
  },
  methods: {
    // 返回
    onClickLeft() {
      this.$router.go(-1);
    },
    // 首次加载和下拉刷新
    onRefresh() {
      this.pageNum = 1;
      this.loadData("downRefresh");
    },
    // 上拉加载，滚动条与底部距离小于 offset 时触发
    onReachBottom() {
      ++this.pageNum;
      this.loadData("downRefresh");
    },
    //数据处理
    loadData(type) {
      if (type === "downRefresh") {
        this.getInvoiceList("downRefresh");
      } else {
        this.refreshing = false; // 关闭顶部加载中···
      }
    },
    //跳转发票详情
    goDetail(val) {
      this.$router.push({ path: "/invoiceDetail", query: { id: val.id } });
      // localStorage.setItem('invoiceDetail',JSON.stringify(val))
    },
    // 获取历史发票列表
    getInvoiceList(type) {
      this.loading = true;
      this.finished = false;
      _invoiceList({
        currentPage: this.pageNum,
        pageSize: 10,
      })
        .then((res) => {
          if (res && res.code == 200) {
            let result = res.data;
            if (type == "downRefresh") {
              this.list = [...this.list, ...result.record];
            } else {
              this.list = result.record || [];
            }
            if (res.data.pages == this.pageNum || this.list.length == 0) {
              this.finished = true;
              this.finishedText = "已加载完全部数据";
            }
            this.loading = false;
          } else {
            Toast(res.message);
            this.loading = false;
            this.finished = true;
            this.finishedText = "";
          }
        })
        .catch((err) => {
          this.finishedText = "";
          this.finished = true;
          throw err;
        })
        .finally(() => {});
    },
  },
};
</script>
<style lang="scss" scoped>
.invoiceHistory {
  height: 100%;
  background: #f5f7fa;
  .invoiceHistory_content {
    padding-top: 48px;
    height: 100%;
    .invoiceHistory_content_listBox {
      margin-top: 12px;
      background: #f5f7fa;
      .invoiceHistory_content_list {
        width: 335px;
        background: #ffffff;
        border-radius: 8px;
        padding: 20px;
        margin-bottom: 8px;
        margin-left: 20px;
        .invoiceHistory_content_list_top {
          display: flex;
          justify-content: space-between;
          margin-bottom: 8px;
          .invoiceHistory_content_list_top_time {
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #626a6b;
          }
          .invoiceHistory_content_list_top_flag {
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
          }
        }
        .invoiceHistory_content_list_name {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #626a6b;
        }
        .invoiceHistory_content_list_price {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-top: 2px;
          .invoiceHistory_content_list_price_left {
            font-size: 13px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #2e4344;
          }
          .invoiceHistory_content_list_price_rig {
            font-size: 18px;
            font-family: DINAlternate-Bold, DINAlternate;
            font-weight: bold;
            color: #2e4344;
          }
        }
      }
    }
  }
  .noData {
    text-align: center;
    margin: 0 auto;
    margin-top: 84px;
    img {
      width: 140px;
    }
    p {
      margin-top: 20px;
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #aaaaaa;
    }
  }
}
</style>
